import { onDocumentLoaded } from "../utils/on-document-loaded.js";


onDocumentLoaded(() => {
    console.log("[smart supply page]");
});